<template>
  <footer class="footer">
    <div class="container footer__wrapper">
      <div>
        <nav
          class="navigation margin__t--12"
          v-if="column_1.links?.length"
        >
          <ul class="navigation__ul">
            <li
              v-for="({ link }, index) in column_1.links"
              :key="`navigation_${index}`"
              class="navigation__li"
            >
              <app-link
                :link="link"
                class="navigation__link link--naked link__color--white-prim bold"
              />
            </li>
          </ul>
        </nav>
      </div>

      <div>
        <address
          v-if="translate(column_2.address)"
          v-html="translate(column_2.address)?.replace(/\n/g, '<br>')"
        />

        <a
          class="link__color--white-prim link--naked bold d-inline-block margin__t--12"
          :href="`mailto:translate(${column_2.email})`"
        >
          {{ translate(column_2.email) }}
        </a>
      </div>

      <div class="d-sm-flex justify-content-end">
        <div>
          <h4
            class="footer__title margin__b--6"
            v-if="column_3.title"
          >
            {{ translate(column_3.title) }}
          </h4>

          <app-social-networks />

          <app-link
            :link="column_3.cta"
            class="link__color--white-prim link--naked d-inline-block margin__t--12 padding--6 bold cta"
          />
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { useI18n } from '@/vendors/i18n'

import AppSocialNetworks from '&/molecules/AppSocialNetworks'
const AppLink = defineAsyncComponent(() => import('&/atoms/AppLink'))

const { section } = defineProps({
  section: { type: Object, required: true }
})

const { translate } = useI18n()

const { column_1 = {}, column_2 = {}, column_3 = {} } = section.attributes
</script>

<style lang="scss" scoped>
$color--primary: #adab00;
$color--tertiary: #438382;

.footer {
  background: $color--tertiary;
  padding-block: 36px;
  font-size: rem(18px);
  color: $white;
  font-weight: bold;
  line-height: 1.5;
  white-space: nowrap;

  &__wrapper {
    display: grid;
    grid-template-columns: 1fr;
    gap: 36px;

    @include mq(sm) {
      grid-template-columns: min-content min-content auto;
      gap: 100px;
    }
  }
}

.navigation {
  &__li {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
}

:deep() {
  .networks {
    &__ul {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      font-size: rem(15px);
    }

    &__a {
      color: $white;

      &:hover {
        color: $color--primary;
      }
    }
  }
}

:deep(.cta) {
  border-bottom: 2px solid currentColor;
}

// footer {
//   background-color: $color-second;
//   color:$white;
//   font-family: $font-family--primary;
//   font-size: rem(18px);
// }

// .wrapper {
//   margin: 0 auto;
//   padding: $padding__base * 3;

//   @include mq(sm) {
//     display: flex;
//     padding: $padding__base * 3 $padding__base * 3;
//   }

//   @include mq(md) {
//     padding: $padding__base * 3 $padding__base * 5;
//   }

//   @include mq(lg) {
//     padding: $padding__base * 3 $padding__base * 10;
//   }
// }

// .block {
//   display: flex;
//   flex-direction: column;
//   margin-bottom: $margin__base * 3;
//   text-align: center;

//   @include mq(sm) {
//     margin: 0;
//     text-align: left;
//   }

//   &:last-child {
//     margin-bottom: 0;
//   }

//   &__el {
//     margin-bottom: $margin__base;

//     &:last-child {
//       margin-bottom: 0;
//     }

//     &--address span{
//       display: block;
//     }
//   }

//   @include mq(sm) {
//     &:nth-child(1){
//       margin-right: 100px;
//     }

//     &:last-child {
//       align-self: end;
//       display: flex;
//       flex-direction: column;
//       height: 100%;
//       justify-content: space-between;
//       margin-left: auto;
//     }
//   }

//   &__button {
//     border-bottom: 3px solid $white;

//     &:hover, :focus {
//       border-color: $color-principal;
//     }
//   }
// }

// .networks {
//   display: flex;
//   font-size: rem(14px);
//   justify-content: center;
//   margin-top: calc($margin__base / 2);

//   @include mq(sm){
//     justify-content: flex-start;
//   }

//   &__el {
//     overflow: hidden;
//     position: relative;

//     &:not(:first-of-type){
//       margin-left: $margin__base;
//     }
//   }

//   &__span {
//     position: absolute;
//     left: 0;
//     overflow: hidden;
//     width: 0;
//   }
// }

// .link {
//   color: $white;
//   transition: all $transition__duration;

//   &:hover,
//   &:focus {
//     color: $color-principal;
//   }
// }

</style>
